export const LIST_GROUPS = 'LIST_GROUPS';
export const SET_GROUP = 'SET_GROUP';
export const SET_GROUP_DROPDOWN = 'SET_GROUP_DROPDOWN';
